import renderSpousal from './render';

export default (uuid: string, token: string): void => {
  const script = document.createElement('script');

  script.type = 'text/javascript';
  script.src = `${process.env.MONOLITH_HOST_URL}/widgets.js?async=true&bundle_name=spousal`;
  script.async = true;
  script.onload = () => {
    renderSpousal(uuid, token);
  };
  document.head.appendChild(script);
};
